// Actions MEMBERS
export const GET_MEMBERS = "GET_MEMBERS";
export const CLEAN_MEMBERS = "CLEAN_MEMBERS";
export const UPDATE_MEMBERS = "UPDATE_MEMBERS";